export const Auction = [
  {
    name: '간편검색',
    url: '/search?type=e',
  },
  {
    name: '종합검색',
    url: '/search?type=c',
  },
  {
    name: '경매일정',
    url: '/auctionSchedule',
  },
  {
    name: '경매신건',
    url: '/NewAuction',
  },
];

export const BadDebt = [
  {
    name: 'NPL 검색',
    url: '/search/npl',
  },
  // {
  //   name: '채권거래소',
  //   // url: '/search/bond',
  //   url: '',
  // },
];
export const MyAiAnalysis = [
  {
    name: '나만의 알고리즘 만들기',
    url: '/myAlgorithm',
  },
  {
    name: '나만의 알고리즘 보관함',
    url: '/myPetternList',
  },
  {
    name: 'AI 기반 실시간 경매 추천',
    url: '/AiRecommendation',
  },

  {
    name: '퀀트 분석 기반 테마 추천',
    url: '/quant',
  },
];
export const Mypage = [
  {
    name: '관심물건',
    url: '/mypage',
  },
  {
    name: '최근 본 물건',
    url: '/mypage',
  },
  {
    name: '멤버십',
    url: '/payment/plan',
  },
  {
    name: '결제 내역',
    url: '/mypage/payment',
  },
  {
    name: '내 정보 수정',
    url: '/mypage',
  },
];
export const CS = [
  {
    name: '공지사항',
    url: '/board',
  },
  {
    name: 'FAQ',
    url: 'https://transfarmer.notion.site/zipgo-auction-faq',
  },
  {
    name: '1:1 문의',
    url: '',
  },
];
